import { render } from "./TdHomeView.vue?vue&type=template&id=58597ece&scoped=true"
import script from "./TdHomeView.vue?vue&type=script&lang=js"
export * from "./TdHomeView.vue?vue&type=script&lang=js"

import "./TdHomeView.vue?vue&type=style&index=0&id=58597ece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58597ece"]])

export default __exports__